import { Head, useForm, Link } from '@inertiajs/react'
import { FormEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface Props {
  flash: {
    alert?: string
  }
}

export default function New({ flash }: Props) {
  const { t } = useTranslation()
  const { data, setData, post, processing } = useForm({
    email_address: '',
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post('/passwords')
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Head title={t('auth.forgotPassword.title')} />

      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl">{t('auth.forgotPassword.title')}</CardTitle>
          <CardDescription>
            {t('auth.forgotPassword.description')}
          </CardDescription>
        </CardHeader>

        <CardContent>
          {flash.alert && (
            <div className="mb-4 rounded-md bg-destructive/10 p-3 text-sm text-destructive">
              {flash.alert}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email_address">{t('common.email')}</Label>
              <Input
                id="email_address"
                type="email"
                placeholder={t('common.emailPlaceholder')}
                value={data.email_address}
                onChange={(e) => setData('email_address', e.target.value)}
                required
                autoFocus
                autoComplete="username"
              />
            </div>

            <div className="flex items-center justify-between pt-2">
              <Button type="submit" disabled={processing}>
                {processing ? t('auth.forgotPassword.submitting') : t('auth.forgotPassword.submit')}
              </Button>

              <Link
                href="/session/new"
                className="text-sm text-muted-foreground hover:text-foreground hover:underline"
              >
                {t('common.backToSignIn')}
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
